import moment from 'moment';

import { campaignLineStatuses } from '../../campaign-editor/constants';
import { INTERNAL_DATE_FORMAT } from '../../utils/constants';

function getDefaultDates(product, campaign) {
  if (product.overwriteTimeRange) {
    return { startDate: null, endDate: null };
  }
  const hasPassed = moment(campaign.startDatePlan).isBefore();
  const tomorrow = moment().add(1, 'days').format(INTERNAL_DATE_FORMAT);

  return {
    startDate: hasPassed ? tomorrow : campaign.startDatePlan,
    endDate: campaign.endDatePlan,
  };
}

function getDefaultPrice(defaultPrice) {
  if (!defaultPrice) {
    return 0;
  }
  return defaultPrice > 1 ? defaultPrice : defaultPrice * 100;
}

export default function initializeCampaignLineFrom({
  campaign,
  country = {},
  product,
  pricing,
  gender,
}) {
  const defaultPrice = getDefaultPrice(product.defaultPrice);
  return {
    country,
    product,
    pricing,
    gender,
    netClientBudget: 0,
    coInvest: 0,
    freeService: 0,
    // Quick fix, until BE migrates column to allow nullable dates
    ...getDefaultDates(product, campaign),
    status: campaignLineStatuses.DRAFT,
    originalFee: defaultPrice,
    adjustedFee: defaultPrice,
  };
}
